<template>
  <div id="hyra-ut-bostadsratt">

<h1>Hyra ut bostadsrätt</h1>
<p>Det finns några viktiga faktorer att tänka på om du skall hyra ut en bostadsrätt i andrahand. Hyran du får ta ut regleras av <strong>privatuthyrningslagen</strong>, men detta gäller bara den första bostadsrätten du hyr ut, om du hyr ut två bostadsrätter.</p>
<p>Om du hyr ut <strong>fler än två</strong> bostadsrätter så är det istället <strong>hyreslagen</strong> som reglerar vad du får ta i hyra.</p>

<h2>Vad får man ta i hyra</h2>
<p>När du hyr ut en bostadsrätt har du rätt att ta ut en <router-link v-bind:to="'/kostnadsbaserad-hyra'">kostnadsbaserad hyra</router-link></p>


<h2>Länkar</h2>
<p><a href="http://www.notisum.se/Pub/Doc.aspx?url=/rnp/sls/lag/20120978.htm">Privatuthyrningslagen</a></p>
  </div>
</template>

<script>
export default {
  name: 'hyra-ut-bostadsratt'
}
</script>
<!-- styling for the component -->
<style>

</style>



// WEBPACK FOOTER //
// Bostadsratt.vue?ab35415a